import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme } from '@mui/material/styles';
import { PROMETHEAN_TYPOGRAPHY_BUTTON_SMALL } from '../styles/typography/typography';
import { PROMETHEAN_NEUTRAL_MID_GREY, PROMETHEAN_TEXT } from '../styles/colors/colors';
export var tagTheme = createTheme({
  components: {
    MuiChip: {
      styleOverrides: {
        root: {
          height: 24,
          '&.MuiChip-filled': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_BUTTON_SMALL), {}, {
            backgroundColor: PROMETHEAN_NEUTRAL_MID_GREY,
            borderRadius: '100px',
            '.MuiChip-deleteIcon': {
              color: PROMETHEAN_TEXT,
              fontSize: 16
            }
          })
        }
      }
    }
  }
});